import {FC} from "react";
import {IAchievement} from "modules/reducers";
import {IMAGES_URL} from "modules/constants";
import {LockedBadge} from "components";
import {Img, Container, Wrapper} from "./common";

interface IBadge {
	achievement?: IAchievement;
	height?: string;
	width?: string;
	className?: string;
}

export const Badge: FC<IBadge> = ({height, width, achievement, className}) => {
	if (!achievement || !achievement.earned) {
		return <LockedBadge height={height} width={width} className={className} />;
	}

	return (
		<Wrapper $width={width} $height={height}>
			<Container>
				<Img src={`${IMAGES_URL}budges/${achievement.name}.svg`} alt={""} />
			</Container>
		</Wrapper>
	);
};
